<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box form-inline">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-6 text-left">
                <div class="form-group text-left">
                  <!--
                  <router-link :to="{path: '/crPrinter'}">
                    <div class="btn btn-default btn-table-title">新增出單機</div>
                  </router-link>
                  -->
                  <div class="form-group">
                    <select class="form-control h-38" v-model="statusSelect">
                      <option :value="99">== 對帳狀態 ==</option>
                      <option :value="2 ">訂單帳務有衝突</option>
                      <option :value="3">帳務紀錄有缺</option>
                      <option :value="4">帳務記錄冗余</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select class="form-control h-38" v-model="processedSelect">
                      <option :value="99">== 處理狀態 ==</option>
                      <option :value="1">已處理</option>
                      <option :value="0">未處理</option>
                    </select>
                  </div>
                </div>
              </div>
              <!--
              <div class="col-sm-6 text-right">
                <div class="form-group">
                  <select class="form-control h-38" v-model="searchSelect">
                    <option :value="1">交易編號</option>
                    <option :value="2">交易日期</option>
                  </select>
                </div>
                <div class="form-group search-bar">
                  <div class="input-group" v-if="searchSelect === 1">
                    <input class="form-control" type="text" v-model="searchResult">
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                  <div class="input-group time-box" v-else-if="searchSelect === 2">
                    <date-time-picker :date="menuTime.tradeDate" :option="dateoption" :limit="tradeLimit"></date-time-picker>
                    <span class="input-group-addon c-pointer" @click="clickPage(1)"><i class="fa fa-search"></i></span>
                  </div>
                </div>
              </div>
              -->
            </div>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">錯誤ID</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易序號</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">金額</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">交易類型</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">處理狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">對帳狀態</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">建立時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">更新時間</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""></th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="accountList.length > 0">
                  <tr class="even" role="row" v-for="(account, index) in accountList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <!--<td>-->
                      <!--{{account.error_id}}-->
                    <!--</td>-->
                    <td>{{account.trade_identifier}}</td>
                    <td>
                      $ {{account.money}}
                    </td>
                    <td>
                      <span v-if="account.accounting_type === 1" class="label label-success">付款</span>
                      <span v-else-if="account.accounting_type === 2"  class="label label-danger">退款</span>
                    </td>
                    <td>
                      <span v-if="account.is_processed" class="label label-success">已處理</span>
                      <span v-else-if="!account.is_processed"  class="label label-default">未處理</span>
                    </td>
                    <td>
                      <span v-if="account.status === 2"  class="label label-danger">失敗 訂單帳務有衝突</span>
                      <span v-else-if="account.status === 3"  class="label label-danger">失敗 帳務紀錄有缺</span>
                      <span v-else-if="account.status === 4"  class="label label-danger">失敗 帳務記錄冗余</span>
                      <span v-else class="label label-default">尚未對帳</span>
                    </td>
                    <td>{{account.create_time}}</td>
                    <td>{{account.update_time}}</td>
                    <td>
                      <button class="btn btn-default" @click="getCurrentId(account.error_id, account.is_processed)" data-toggle="modal" data-target="#confirmModal"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else-if="accountList.length === 0">
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="brandPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="confirmOption" @trigger="trigger" :selectOptions="selectOptions" @selectOnChange="selectOnChange"></m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import moment from 'moment'
export default {
  name: 'Tables',
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      total: 1,
      count: 10,
      searchSelect: 1,
      searchResult: '',
      accountList: [],
      statusSelect: 99,
      processedSelect: 99,
      // date
      menuTime: {
        tradeDate: {
          time: moment().add(-1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      tradeLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      confirmOption: {
        id: 'confirmModal',
        title: '修改評分狀態',
        body: '確認修改評分狀態？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'upConfirmed'
          }
        ]
      },
      selectOptions: {
        name: '帳務處理',
        options: [
          { text: '已處理', value: 1 },
          { text: '未處理', value: 0 }
        ]
      },
      cAccount: {
        accountId: '',
        isConfirm: '',
        newIsConfirm: 0
      },
      isLoading: true
    }
  },
  mounted () {
  },
  methods: {
    getCurrentId (accountId, isConfirm) {
      this.cAccount.accountId = accountId
      this.cAccount.isConfirm = isConfirm
    },
    upConfirmed () {
      var self = this
      var url = '/accounting/error/' + this.cAccount.accountId
      var data = {
        is_processed: this.cAccount.newIsConfirm
      }
      this.getDataH('put', url, data, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: response.data.message,
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.getAccountList()
        }
      })
    },
    trigger (event) {
      if (event === 'upConfirmed') {
        this.upConfirmed()
      }
    },
    selectOnChange (value) {
      this.cAccount.newIsConfirm = value
    },
    printerType (type) {
      switch (type) {
        case 1: return '熒埔'
        case 2: return '飛鵝'
      }
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getAccountList()
    },
    getAccountList () {
      this.isLoading = true
      var self = this
      var data = {
        page: this.tableIndex,
        size: this.count
      }
      var url = '/accounting/error/list?page=' + data.page + '&size=' + data.size
      if (this.statusSelect !== 99) url = url + '&status=' + this.statusSelect
      if (this.processedSelect !== 99) url = url + '&is_processed=' + this.processedSelect
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.accountList = response.data.list
          self.total = response.data.total
          self.isLoading = false
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  created () {
    this.fixedH()
    this.getAccountList()
  },
  watch: {
    statusSelect () {
      this.clickPage(1)
    },
    processedSelect () {
      this.clickPage(1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CashAccountErrorTable.vue?a87a53e4